import Title from '@src/containers/App/Auth/components/Title';
import IntlMessages from '@src/util/IntlMessages';
import CardButtonAccess from '../components/CardButtonAccess';

import { useOptionPickerView } from '../hooks/useOptionPickerView';

import styles from './OptionPickerView.module.less';

export default function OptionPickerView() {
  const { access } = useOptionPickerView();
  return (
    <div className="gx-h-100 gx-m-5 gx-overflow-auto">
      <div className="gx-flex-column gx-justify-content-between gx-h-100">
        <div>
          <div className="gx-flex-row gx-justify-content-center">
            <Title>
              <IntlMessages id="app.welcome.operonda" />
            </Title>
          </div>

          <div className={`gx-mt-5 ${styles.cardGrid}`}>
            {access.map((item, index) => (
              <CardButtonAccess
                key={index}
                title={item.title}
                Icon={item.Icon}
                href={item.href}
                hrefs={item.hrefs}
              />
            ))}
          </div>
        </div>

        <div className="gx-pb-5">
          <div className="gx-flex-row gx-justify-content-xs-start gx-justify-content-md-center gx-m-5 gx-guarnic-gap-2">
            <div className="gx-pr-2">
              <span className="gx-guarnic-label"> Prestador de servicios:</span>{' '}
              <span>Guarnic SpA, RUT: 76.416.896-8</span>
            </div>
            <div className="gx-pr-2">
              <span className="gx-guarnic-label"> Tipo de aplicación:</span> <span>WEB</span>
            </div>
            <div className="gx-pr-2">
              <span className="gx-guarnic-label"> Navegadores compatibles:</span>{' '}
              <span>
                Chrome Version 120.x en adelante, Mozilla Firefox Version 121.0 en adelante, Safari
                Version 17.1 en adelante
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
